export { migrationPublishMessages } from './messages';

export const MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM = 'migrationPublished';

const DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH = '/servicedesk/customer/test/portals';

export const isDefaultHelpCenterPortalsPreviewPath = (pathname: string): boolean =>
	pathname === DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH ||
	pathname === `${DEFAULT_HELP_CENTER_PORTALS_PREVIEW_PATH}/`;

export const getMigrationPublishedUrl = (url: string): string => {
	const destination = new URL(url);
	destination.searchParams.set(MIGRATION_PUBLISH_SUCCESS_QUERY_PARAM, 'true');
	return destination.toString();
};
